export const replaceNewLinesWithSpaces = str => {
  return str ? str.replace(/(?:\r\n|\r|\n)/g, ' ') : '';
};
